import React, { useEffect, useRef } from 'react';
import { useApp } from '@/context/AppContext';
import { dashboardUrlFor, DASHBOARD_URL } from '@/lib/dashboard';
import { Loader2, ExternalLink } from 'lucide-react';

// Sleeping-partner flow: after login the partner is redirected straight to the
// external Management Dashboard (shabzclosetdash.in). No Billing UI, no operational
// menus. SSO is not attempted (separate app, no shared auth); the external dashboard
// keeps its own login. A visible manual link is shown as a fallback if the automatic
// redirect is blocked or slow. Fully responsive (phone/tablet/desktop).
export default function PartnerHome() {
  const { user, logout } = useApp();
  const done = useRef(false);
  const url = dashboardUrlFor(user);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    // Full-page redirect (we are leaving the Billing app on purpose).
    try { window.location.replace(url); } catch (e) { window.location.href = url; }
  }, [url]);

  return (
    <div className="app-bg flex min-h-screen flex-col items-center justify-center px-5 py-10" data-testid="partner-home">
      <div className="w-full max-w-md rounded-3xl border border-border bg-card p-7 text-center shadow-xl">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15 text-primary">
          <Loader2 className="h-7 w-7 animate-spin" />
        </div>
        <h1 className="mt-5 font-display text-xl font-semibold">Taking you to your dashboard…</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You are being redirected to the SHABZ CLOSET Management Dashboard.
        </p>
        <a
          data-testid="partner-dashboard-link"
          href={url}
          className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-primary px-4 py-4 text-base font-semibold text-primary-foreground transition-transform active:scale-[0.98]">
          <ExternalLink className="h-5 w-5" /> Open {DASHBOARD_URL.replace('https://', '')}
        </a>
        <button
          data-testid="partner-logout"
          onClick={logout}
          className="mt-4 text-xs font-medium text-muted-foreground underline underline-offset-2">
          Sign out
        </button>
      </div>
    </div>
  );
}
